"use client";
import React, { useState } from "react";
import InputField from "./../components/common/InputField";
import { useNavigate } from "react-router-dom";


const RegistrationForm = () => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        username: "",
        firstName: "",
        lastName: "",
        password: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear error when user types
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.username.trim()) {
            newErrors.username = "Username is required";
        }

        if (!formData.firstName.trim()) {
            newErrors.firstName = "First name is required";
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = "Last name is required";
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }

        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            // Handle registration logic here
            console.log("Registration attempt with:", formData);
        }
    };

    const handleLoginRedirect = () => {
        // Navigate to login page using React Router
        navigate("/login");
    };

    return (
        <section className="flex flex-col gap-6 items-start mt-64 w-[500px] max-md:mt-32 max-md:max-w-[500px] max-md:w-[90%] max-sm:mt-20 max-sm:w-[95%]">
            <h1 className="w-full text-3xl font-semibold leading-9 text-center text-gray-700 max-sm:text-2xl max-sm:leading-8">
                Join our forum community
            </h1>

            <form
                onSubmit={handleSubmit}
                className="flex flex-col gap-4 items-start w-full"
            >
                {/* Username field (first row) */}
                <InputField
                    label="Username"
                    placeholder="Choose a username"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    error={errors.username}
                />

                {/* First name and Last name (second row) */}
                <div className="flex gap-4 w-full max-sm:flex-col">
                    <InputField
                        label="First Name"
                        placeholder="Enter your first name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                        error={errors.firstName}
                    />

                    <InputField
                        label="Last Name"
                        placeholder="Enter your last name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                        error={errors.lastName}
                    />
                </div>

                {/* Password and Confirm Password (third row) */}
                <InputField
                    label="Password"
                    placeholder="Create a password"
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    error={errors.password}
                />

                <InputField
                    label="Confirm Password"
                    placeholder="Confirm your password"
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    error={errors.confirmPassword}
                />

                {/* Buttons */}
                <div className="flex flex-col gap-3 items-start w-full mt-2">
                    <button
                        type="submit"
                        className="gap-2 px-6 py-3 w-full text-base font-medium leading-7 text-white bg-rose-700 h-[50px] rounded-[400px] max-sm:h-11"
                    >
                        Registration
                    </button>

                    <button
                        type="button"
                        onClick={handleLoginRedirect}
                        className="gap-2 px-6 py-3 w-full text-base font-medium leading-7 text-rose-700 border border-rose-700 border-solid h-[50px] rounded-[400px] max-sm:h-11"
                    >
                        Login
                    </button>
                </div>
            </form>
        </section>
    );
};

export default RegistrationForm;
